import AuthApiService from '@services/auth.api.service';
import JWTService from '@services/jwt.service';

import { AzureADLoginHelper } from '@helpers';

import { MAIN_ROUTE_NAME } from '@config/routeInformation';

import { MutationTypes, ActionTypes } from '@store/modules/auth.types';
import { namespace as AppNamespace } from '@store/modules/app.types';

export default {
  namespaced: true,
  state: {
    token: JWTService.getToken(),
    code: JWTService.getCode(),
    isAuthenticated: false,
    returnUrl: null,
  },
  mutations: {
    [MutationTypes.SET_AUTH](state, payload) {
      state.isAuthenticated = payload;
    },
    [MutationTypes.SET_TOKEN](state, payload) {
      state.token = payload;
      if (payload) {
        JWTService.setToken(payload);
      } else {
        JWTService.removeToken();
      }
    },
    [MutationTypes.SET_CODE](state, payload) {
      state.code = payload;
      if (payload) {
        JWTService.setCode(payload);
      } else {
        JWTService.removeCode();
      }
    },
    [MutationTypes.SET_RETURN_URL](state, payload) {
      state.returnUrl = payload;
    },
  },
  actions: {
    async [ActionTypes.GENERATE_TOKEN_FROM_URL](
      { state: { token: TOKEN }, commit, dispatch },
      { query },
    ) {
      const q = JSON.parse(JSON.stringify(query));
      const { umToken: UM_TOKEN } = q;

      if (!UM_TOKEN && !TOKEN) {
        dispatch(ActionTypes.LOGOUT, { routeName: 'login' });
        return Promise.reject();
      }

      JWTService.setToken(UM_TOKEN || TOKEN);

      await AuthApiService.checkUserAuth();

      commit(MutationTypes.SET_AUTH, true);

      if (UM_TOKEN) {
        commit(MutationTypes.SET_TOKEN, UM_TOKEN);
        commit(MutationTypes.SET_CODE, q.code);

        delete q.umToken;
        delete q.expires;
        delete q.code;
      }

      return Promise.resolve(q);
    },
    [ActionTypes.LOGIN]({
      state: { returnUrl },
      rootState: {
        [AppNamespace]: { userManagerUrl, clientId },
      },
    }) {
      const defaultUrlQuery = '?pageNum=1&activeOnly=true';
      const adHelper = new AzureADLoginHelper(
        {
          authUrl: userManagerUrl,
          umClientId: clientId,
        },
        returnUrl || `${window.location.origin}/${MAIN_ROUTE_NAME}${defaultUrlQuery}`,
      );
      adHelper.login();
    },
    [ActionTypes.LOGOUT]({ commit }, { routeName } = {}) {
      commit(MutationTypes.SET_TOKEN, null);
      commit(MutationTypes.SET_AUTH, false);

      if (routeName !== 'login' && routeName !== 'forbidden') {
        commit(MutationTypes.SET_RETURN_URL, window.location.href);
      }
    },
  },
};
